/**
 * Global CORS-safe fetch: all relative URLs (e.g. /cart.js, /products.json) are
 * resolved to the current origin and sent with credentials: 'same-origin'.
 * Prevents CORS origin issues on dev, proxy, and custom domains.
 */
(function () {
	var nativeFetch = window.fetch.bind(window);
	var origin = typeof window.location.origin === 'string' && window.location.origin
		? window.location.origin
		: window.location.protocol + '//' + window.location.host;

	function isRelativeUrl(url) {
		if (typeof url !== 'string') return false;
		return url.charAt(0) === '/' && url.charAt(1) !== '/';
	}

	window.fetch = function (url, options) {
		var resolvedUrl = url;
		var opts = options != null ? Object.assign({}, options) : {};
		if (isRelativeUrl(url)) {
			resolvedUrl = origin + url;
			if (opts.credentials === undefined) opts.credentials = 'same-origin';
		}
		return nativeFetch(resolvedUrl, opts);
	};

	/** Explicit helper for same-origin API calls (optional). */
	window.troyaFetch = function (pathOrUrl, options) {
		var url = typeof pathOrUrl === 'string' && pathOrUrl.indexOf('http') !== 0
			? origin + (pathOrUrl.charAt(0) === '/' ? pathOrUrl : '/' + pathOrUrl)
			: pathOrUrl;
		var opts = options != null ? Object.assign({}, options) : {};
		if (opts.credentials === undefined) opts.credentials = 'same-origin';
		return nativeFetch(url, opts);
	};
})();

/**
 * Cached /cart.js fetcher to avoid 429 Too Many Requests.
 */
(function () {
	var CACHE_TTL_MS = 2000;
	var cached = null;
	var cachedAt = 0;

	window.getCartJs = function (forceRefresh) {
		var now = Date.now();
		if (!forceRefresh && cached != null && now - cachedAt < CACHE_TTL_MS) {
			return Promise.resolve(cached);
		}
		return fetch('/cart.js')
			.then(function (res) {
				if (!res.ok) throw new Error('Cart request failed: ' + res.status);
				return res.json();
			})
			.then(function (data) {
				cached = data;
				cachedAt = Date.now();
				return data;
			});
	};

	window.invalidateCartCache = function () {
		cached = null;
		cachedAt = 0;
	};

	window.addEventListener('basketUpdated', function () {
		window.invalidateCartCache();
	});
})();

$('header #header-basket-button').on('click', (e) => {
	e.preventDefault();

	window.dispatchEvent(new CustomEvent('toggleBasketSidebar'))
})
$('.header-mobile #header-basket-button').on('click', (e) => {
	e.preventDefault();

	window.dispatchEvent(new CustomEvent('toggleBasketSidebar'))
})

let wishlistItems = window.localStorage.getItem('wishlist')
	? JSON.parse(window.localStorage.getItem('wishlist'))
	: [];

if (wishlistItems.length) {
	if (window.innerWidth > 768) {
		$('#header-wishlist-button').append(`<span>${wishlistItems.length}</span>`)
	} else {
		$('.header-mobile-menu #header-wishlist-button').append(`<span>${wishlistItems.length}</span>`)
	}
}

$('.faq-list-item-title').on('click', function () {
	$(this).next().stop().slideToggle();
})

$('.blog-list-slider').owlCarousel({
	loop: true,
	margin: 15,
	autoplay: true,
	autoplayTimeout: 5000,
	nav: window.innerWidth > 767,
	dots: window.innerWidth <= 767,
	autoHeight: true,
	navText: [
		'<button class="carousel-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
		'<button class="carousel-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
	],
	responsive: {
		0: {
			items: 1,
			dots: true,
			nav: false,
			dotsEach: 3
		},
		768: {
			items: 2,
			dots: false,
			nav: true
		},
		992: {
			items: 3,
			dots: false,
			nav: true
		},
		1200: {
			items: 3,
			dots: false,
			nav: true
		}
	}
}).trigger('refresh.owl.carousel');

// To Price Function
function toPrice(price) {
	return (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function toPriceWithSmallCents(price) {
	const formatted = (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
	const parts = formatted.split('.');
	if (parts.length === 2) {
		return parts[0] + '.<span class="small-cents">' + parts[1] + '</span>';
	}
	return formatted;
}

function getPercentageChange(oldNumber, newNumber){
	var decreaseValue = oldNumber - newNumber;

	return ((decreaseValue / oldNumber) * 100).toFixed(0);
}

if (window.location.href.includes('?contact%5Btags%5D=newsletter&form_type=customer')) {
	$('html, body').scrollTop($('.email-subscription').offset().top);
	
	$('.email-subscription .error').css('display', 'block');
}else {
	$('.email-subscription .error').css('display', 'none');
}

$('.gallery-item').on('click', function () {
	// Gallery list section uses its own testimonial-style modal
	if ($(this).closest('.gallery-list-section').length) return;

	const arr = []
	
	$(this).find('.gallery-item-image').map(function () {
		if ($(this).data('product-title')) {
			arr.push(`
				<a href="/products/${$(this).data('product-handle')}" target="_blank">
					<div>${$(this).data('product-title')} Product</div>
					<img src="https:${$(this).find('img').attr('src')}" alt="" />
				</a>
			`);
		} else {
			arr.push(`<img src="https:${$(this).find('img').attr('src')}" alt="" />`);
		}
	});
	
	$('.gallery-modal-contain-body-images').html(arr.join(''));

	$('body').css('overflow', 'hidden');
	$('.gallery-modal').addClass('show');
	$('.gallery-modal-contain').scrollTop(0)
	$('.gallery-modal-contain-body > a').attr('href', $(this).data('url'))
	$('.gallery-modal').attr('data-index', $(this).parent().index())
});

$(document).on('click', '.gallery-modal-filter, .gallery-modal-close button', function () {
	$('body').css('overflow', 'visible');
	$('.gallery-modal').removeClass('show');
});

$(document).on('click', '.gallery-modal-arrows button', function () {
	const modal = $('.gallery-modal');
	const index = parseInt(modal.attr('data-index'))

	if ($(this).hasClass('prev')) {
		if (index === 0) {
			$(`.tab-pane.active .col-lg-4:nth-child(${$('.tab-pane.active .col-lg-4').length})`).find('.gallery-item').click();
		} else {
			$(`.tab-pane.active .col-lg-4:nth-child(${index})`).find('.gallery-item').click();
		}
	}

	if ($(this).hasClass('next')) {
		if (index === $('.tab-pane.active .col-lg-4').length - 1) {
			$('.tab-pane.active .col-lg-4:nth-child(1)').find('.gallery-item').click();
		} else {
			$(`.tab-pane.active .col-lg-4:nth-child(${index + 2})`).find('.gallery-item').click();
		}
	}
})

$('.item-quantity-input #minus').on('click', function () {
	if ($(this).next().val() > 1) {
		$(this).next().val($(this).next().val() - 1);
		setTimeout(() => {
			$('input[name="update"]').click();
		}, 200)
	}
})

$('.item-quantity-input #plus').on('click', function () {
	$(this).prev().val(parseInt($(this).prev().val()) + 1);
	setTimeout(() => {
		$('input[name="update"]').click();
	}, 200)
})

// if ($('.wishlist-items').length) {
// 	const items = window.localStorage.getItem('wishlist') ? JSON.parse(window.localStorage.getItem('wishlist')) : [];

// 	if (items.length === 0) {
// 		$('p.loading').remove();
// 		$('.wishlist-items').append('<p>No items found.</p>');
// 	} else {
// 		$('p.loading').remove();

// 		items.map((item) => {
// 			$('.wishlist-items').append(`
// 				<div class="item" data-id="${item.id}">
// 					<div class="item-left">
// 						<img src="${item.featured_image}" alt="">
		
// 						<h5>${item.title}</h5>
// 					</div>
		
// 					<div class="item-right">
// 						<a href="/products/${item.handle}">View product</a>
// 						<button>Remove</button>
// 					</div>
// 				</div>
// 			`);
// 		});
// 	}

// 	$('body').on('click', function (e) {
// 		if ($(e.target).parent().hasClass('item-right')) {
// 			const find = items.filter((item) => {
// 				return item.id !== $(e.target).parent().parent().data('id');
// 			});

// 			window.localStorage.setItem('wishlist', JSON.stringify(find));

// 			$(e.target).parent().parent().hide();
// 		}
// 	});
// }

let timeout;

// Preserve the existing "Queen Murphy Bed" fallback while ensuring no search
// form can submit an empty or whitespace-only query.
document.addEventListener('submit', function (e) {
	const form = e.target.closest('form[role="search"]')
	if (!form) return

	const input = form.querySelector('input[name="q"]')
	if (!input || input.value.trim() !== '') return

	const defaultQuery = input.placeholder.trim() === 'Queen Murphy Bed'
		? 'Queen Murphy Bed'
		: ''

	if (defaultQuery) {
		input.value = defaultQuery
		return
	}

	e.preventDefault()
	e.stopImmediatePropagation()
	input.value = ''
	input.focus()
}, true)

$('.search-input-wrapper input[name="q"]').on('keyup', function (e) {
	const input = $(this)
	const container = $(this).parent().parent().parent().find('.search-list')
	const query = input.val().trim()

	clearTimeout(timeout)

	if (query === '' || e.code === 'Escape') {
		container.html('')
		container.hide()
	} else {
		container.show()

		container.html('')
	
		container.append('<p>loading...</p>')
	
		timeout = setTimeout(() => {
			if (input.val().trim() !== query) return

			fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article&resources[options][fields]=title,product_type,variants.title`)
				.then((response) => {
					if (!response.ok) throw new Error(`Search suggestions request failed with status ${response.status}`)
					return response.json()
				})
				.then((suggestions) => suggestions?.resources?.results || { products: [], articles: [] })
				.then(response => {
					if (input.val().trim() !== query) return

					const products = Array.isArray(response.products) ? response.products : []
					const articles = Array.isArray(response.articles) ? response.articles : []

					let productsHTML = ''
					let articlesHTML = ''

					const filteredProducts = products.filter(product => {
						const tags = Array.isArray(product.tags) ? product.tags : []
						return !tags.includes('Sub Product') && !tags.includes('hidden_search')
					})
	
					filteredProducts.map(product => {
						productsHTML += `<li><a href="${product.url}">${product.title}</a></li>`
					})

					articles.map(article => {
						articlesHTML += `<li><a href="${article.url}">${article.title}</a></li>`
					})
	
					container.html('')
	
					container.append(`
						<p style="text-align: left;margin: 0 15px 5px 15px;font-size: 16px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding: 5px 0 5px 0;">Products</p>
						<ul style="margin-bottom: 10px">${productsHTML}</ul>

						<p style="text-align: left;margin: 0 15px 5px 15px;font-size: 16px;border-bottom: 1px solid rgba(0, 0, 0, 0.1);padding: 5px 0 5px 0;">Blog posts</p>
						<ul>${articlesHTML}</ul>
					`)
				})
				.catch(() => {
					if (input.val().trim() === query) {
						container.html('')
						container.hide()
					}
				})
		}, 1000)
	}
})

// Mobile Header
if (window.innerWidth <= 768) {
	var lastScrollTop = 0;
	var threshold = 100;
	var $mobileHeader = $('.header-mobile');
	var $headerSearch = $mobileHeader.children('.header-mobile-search');
	var $headerContact = $mobileHeader.children('.header-mobile-contact');
	var $headerAnnouncement = $('.header-outer > .visit-showroom-message');
	var headerCollapsed = false;
	var announcementVisible = true;
	var headerAnimationDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;

	function updateMobileStickyOffsets() {
		var headerHeight = $('.header-outer').outerHeight() || 0;
		var filterHeight = $('.mobile-filter-button').outerHeight() || 0;
		$('.mobile-filter-button').css('top', headerHeight);
		$('.collection-page-list-category-title').css('top', headerHeight + filterHeight);
		$('.collection-page-list-subcategory-title').css('top', headerHeight + filterHeight + ($('.collection-page-list-subcategory-title').parent().prev().height() || 0));
	}

	function animateHeaderRow($row, visible) {
		// Keep page spacing fixed; only animate rows inside the fixed header.
		$row.stop(true, false)[visible ? 'slideDown' : 'slideUp']({
			duration: headerAnimationDuration,
			progress: updateMobileStickyOffsets,
			complete: updateMobileStickyOffsets
		});
	}

	$('#main-content').css('opacity', '1')

	function onMobileHeaderScroll(e) {
		// Ignore mobile overscroll and do not collapse an active search field.
		var scrollRoot = e.target === document.body ? document.body : document.documentElement;
		var st = Math.max(0, Math.min(scrollRoot.scrollTop || window.pageYOffset, scrollRoot.scrollHeight - scrollRoot.clientHeight));
		if ($headerSearch.find(':focus').length) {
			lastScrollTop = st;
			return;
		}

		if (st < threshold && !announcementVisible) {
			announcementVisible = true;
			animateHeaderRow($headerAnnouncement, true);
		}

		if (Math.abs(st - lastScrollTop) >= threshold || st === 0) {
			var collapse = st > lastScrollTop && st >= threshold;
			if (collapse !== headerCollapsed) {
				headerCollapsed = collapse;
				animateHeaderRow($headerSearch, !collapse);
				animateHeaderRow($headerContact, !collapse);
			}

			if (collapse && announcementVisible) {
				announcementVisible = false;
				animateHeaderRow($headerAnnouncement, false);
			}
		
			lastScrollTop = st <= 0 ? 0 : st;
		}
	}
	window.addEventListener('scroll', onMobileHeaderScroll, { passive: true });
	// On mobile the existing overflow rules make body the scroll container.
	document.body.addEventListener('scroll', onMobileHeaderScroll, { passive: true });
} else {
	$('#main-content').css('opacity', '1')
	$('#main-content').css('padding-top', $('.header-outer').height() + 'px')
	setTimeout(() => {
		$('.collection-page-list-category-title').css('top', $('.header-outer').height())
		$('.collection-page-list-subcategory-title').css('top', $('.header-outer').height() + $('.collection-page-list-subcategory-title').parent().prev().height())
	}, 1000)

	$(window).on('resize', function () {
		$('#main-content').css('padding-top', $('.header-outer').height() + 'px')
	})
}

function closeMobileBigNavigation() {
	var $bigNav = $('.header-mobile-big-navigation')
	if (!$bigNav.length || !$bigNav.is(':visible')) return

	$bigNav.stop(true, true).fadeOut(200)

	// Clear the inline overflow lock instead of forcing 'auto' so that other
	// open overlays (e.g. the Categories menu) can still control body scroll
	// via their own CSS class after this runs.
	document.body.style.overflow = '';

	$('#dynamic-react-root + div > .needsclick').show();
	$('#shopify-chat').show();
}

$('.header-mobile-menu .toggle-menu button').on('click', function () {
	$('.header-mobile-big-navigation').fadeIn(200)

	document.body.style.overflow = 'hidden';
	
	$('#dynamic-react-root + div > .needsclick').hide();
	$('#shopify-chat').hide();
})

$('.header-mobile-big-navigation-close button').on('click', closeMobileBigNavigation)

$('.header-mobile-big-navigation-list > ul > li > button').on('click', function () {
	if ($(this).is('[data-categories-menu]')) return

	$(this).toggleClass('active')
	$(this).next().slideToggle(500)
})

;(function initCategoriesMenu() {
	var $menu = $('[data-categories-panel]')
	var $overlay = $('[data-categories-overlay]')
	var $triggers = $('[data-categories-menu]')
	var $bigNav = $('.header-mobile-big-navigation')
	var hoverTimer = null
	var hoverCloseTimer = null
	var openedFromMobileNav = false

	if (!$menu.length) return

	function isMobileViewport() {
		return window.innerWidth < 992
	}

	function openMenu() {
		// Mobile drill-down: keep hamburger open underneath and slide Categories in from the right.
		openedFromMobileNav = isMobileViewport() && $bigNav.is(':visible')

		if (!openedFromMobileNav) {
			closeMobileBigNavigation()
		}

		$menu
			.toggleClass('is-from-mobile-nav', openedFromMobileNav)
			.addClass('is-open')
			.attr('aria-hidden', 'false')
		$overlay.toggleClass('is-from-mobile-nav', openedFromMobileNav).addClass('is-open')
		$triggers.attr('aria-expanded', 'true')
		$('body').addClass('categories-menu-open')
		document.body.style.overflow = 'hidden'
		$('.mega-menu').stop().slideUp()
		$('.megamenu-filter').removeClass('show')
	}

	var nestedHideTimer = null
	var PANEL_SLIDE_MS = 320

	function closeNested() {
		var $openPanels = $menu.find('[data-category-panel].is-open')

		$menu.removeClass('is-nested is-expanded')
		$openPanels.removeClass('is-open')
		$menu.find('.categories-menu-item.is-active').removeClass('is-active')
		$menu.find('[data-category-open]').attr('aria-expanded', 'false')

		// Keep panels painted during slide-out; [hidden] would kill the transition
		window.clearTimeout(nestedHideTimer)
		nestedHideTimer = window.setTimeout(function () {
			$openPanels.not('.is-open').attr('hidden', true)
		}, PANEL_SLIDE_MS)
	}

	function closeMenu(options) {
		var closeHamburgerToo = !options || options.closeHamburger !== false
		var keepMobileNav = openedFromMobileNav && !closeHamburgerToo

		closeNested()
		$menu
			.removeClass('is-open is-from-mobile-nav')
			.attr('aria-hidden', 'true')
		$overlay.removeClass('is-open is-from-mobile-nav')
		$triggers.attr('aria-expanded', 'false')
		$('body').removeClass('categories-menu-open')
		openedFromMobileNav = false

		if (keepMobileNav) {
			document.body.style.overflow = 'hidden'
			return
		}

		if (closeHamburgerToo && $bigNav.is(':visible')) {
			closeMobileBigNavigation()
			return
		}

		if (!$bigNav.is(':visible')) {
			document.body.style.overflow = ''
		}
	}

	function openNested(categoryId) {
		if (!categoryId) return

		var $panel = $menu.find('[data-category-panel="' + categoryId + '"]')
		if (!$panel.length) return

		var panelEl = $panel[0]
		var alreadyOpen = $panel.hasClass('is-open')

		window.clearTimeout(nestedHideTimer)

		// Close any other open nested panel (animate out), hide the rest
		$menu.find('[data-category-panel]').not($panel).each(function () {
			var $other = $(this)
			if ($other.hasClass('is-open')) {
				$other.removeClass('is-open')
				window.setTimeout(function () {
					if (!$other.hasClass('is-open')) $other.attr('hidden', true)
				}, PANEL_SLIDE_MS)
			} else {
				$other.attr('hidden', true)
			}
		})

		$menu.find('.categories-menu-item.is-active').removeClass('is-active')
		$menu.find('[data-category-open]').attr('aria-expanded', 'false')
		$menu
			.find('[data-category-open="' + categoryId + '"]')
			.attr('aria-expanded', 'true')
			.closest('.categories-menu-item')
			.addClass('is-active')

		if (alreadyOpen) {
			$menu.addClass('is-nested is-expanded')
			return
		}

		// Paint the closed off-screen state first, then slide in next frame.
		// Removing [hidden] and adding .is-open in the same tick skips the transition.
		$panel.removeAttr('hidden')
		void panelEl.offsetWidth
		window.requestAnimationFrame(function () {
			$panel.addClass('is-open')
			$menu.addClass('is-nested is-expanded')
		})
	}

	$triggers.on('click', function (e) {
		e.preventDefault()
		e.stopPropagation()

		if ($menu.hasClass('is-open')) {
			closeMenu({ closeHamburger: true })
			return
		}

		openMenu()
	})

	$overlay.on('click', function () {
		closeMenu({ closeHamburger: true })
	})

	$menu.on('click', '[data-categories-close]', function (e) {
		e.preventDefault()
		closeMenu({ closeHamburger: true })
	})

	// Root back on mobile: return to hamburger without closing it
	$menu.on('click', '[data-categories-back-root]', function (e) {
		e.preventDefault()
		closeMenu({ closeHamburger: false })
	})

	$menu.on('click', '[data-category-back]', function (e) {
		e.preventDefault()
		closeNested()
	})

	$menu.on('click', '[data-category-open]', function (e) {
		e.preventDefault()
		openNested($(this).data('category-open'))
	})

	// Desktop/laptop: hover opens nested panel with a short delay
	$menu.on('mouseenter', '[data-category-open]', function () {
		if (isMobileViewport()) return

		var categoryId = $(this).data('category-open')
		clearTimeout(hoverCloseTimer)
		clearTimeout(hoverTimer)
		hoverTimer = setTimeout(function () {
			openNested(categoryId)
		}, 120)
	})

	// Desktop/laptop: hovering an item without a submenu should close any open nested panel right away
	$menu.on('mouseenter', '.categories-menu-panel--primary .categories-menu-link', function () {
		if (isMobileViewport()) return
		if ($(this).is('[data-category-open]')) return

		clearTimeout(hoverTimer)
		clearTimeout(hoverCloseTimer)
		closeNested()
	})

	$menu.on('mouseleave', '.categories-menu-panel--primary, .categories-menu-panel--secondary', function () {
		if (isMobileViewport()) return

		clearTimeout(hoverTimer)
		clearTimeout(hoverCloseTimer)
		hoverCloseTimer = setTimeout(function () {
			if (!$menu.find('.categories-menu-panel--secondary:hover').length &&
				!$menu.find('.categories-menu-item.is-active:hover').length) {
				closeNested()
			}
		}, 180)
	})

	$(document).on('keydown', function (e) {
		if (e.key === 'Escape' && $menu.hasClass('is-open')) {
			if ($menu.hasClass('is-nested')) {
				closeNested()
				return
			}
			closeMenu({ closeHamburger: !openedFromMobileNav })
		}
	})
})()

// Sadece mobil: sepete-eklendi uyarısı açıkken chat gizle, kapanınca göster (web’e dokunmaz)
window.addEventListener('cartNotificationOpen', function () {
	if (window.innerWidth < 768) $('#shopify-chat').hide()
})
window.addEventListener('cartNotificationClose', function () {
	if (window.innerWidth < 768) $('#shopify-chat').show()
})
